import type { EstadoCaso } from '../../api/mejoraCU2Api';

export const ESTADO_LABEL: Record<EstadoCaso, string> = {
  NUEVO: 'Nuevo',
  EN_ANALISIS: 'En análisis',
  INFO_SOLICITADA: 'Info solicitada',
  RESUELTO: 'Resuelto',
  CERRADO: 'Cerrado',
  RECHAZADO: 'Rechazado',
  REABIERTO: 'Reabierto',
};

export const ESTADO_COLOR: Record<EstadoCaso, string> = {
  NUEVO: 'blue',
  EN_ANALISIS: 'gold',
  INFO_SOLICITADA: 'orange',
  RESUELTO: 'green',
  CERRADO: 'default',
  RECHAZADO: 'red',
  REABIERTO: 'purple',
};

export interface Capacidades { tratar: boolean; gestionar: boolean; }

type Recurso = 'Tratar' | 'Gestionar';
interface Transicion { origen: EstadoCaso; destino: EstadoCaso; recurso: Recurso; exigeTratamiento?: boolean; exigeMejora?: boolean; }

// Espejo exacto de MejoraCU2Transiciones (backend).
export const TRANSICIONES: Transicion[] = [
  { origen: 'NUEVO', destino: 'EN_ANALISIS', recurso: 'Tratar' },
  { origen: 'EN_ANALISIS', destino: 'INFO_SOLICITADA', recurso: 'Tratar' },
  { origen: 'INFO_SOLICITADA', destino: 'EN_ANALISIS', recurso: 'Gestionar' },
  { origen: 'EN_ANALISIS', destino: 'RESUELTO', recurso: 'Tratar', exigeTratamiento: true, exigeMejora: true },
  { origen: 'EN_ANALISIS', destino: 'RECHAZADO', recurso: 'Tratar', exigeTratamiento: true },
  { origen: 'RESUELTO', destino: 'CERRADO', recurso: 'Gestionar' },
  { origen: 'RESUELTO', destino: 'REABIERTO', recurso: 'Gestionar' },
  { origen: 'RECHAZADO', destino: 'CERRADO', recurso: 'Gestionar' },
  { origen: 'RECHAZADO', destino: 'EN_ANALISIS', recurso: 'Gestionar' },
  { origen: 'REABIERTO', destino: 'EN_ANALISIS', recurso: 'Tratar' },
  { origen: 'CERRADO', destino: 'REABIERTO', recurso: 'Gestionar' },
];

export const transicionesDisponibles = (estado: EstadoCaso, cap: Capacidades): Transicion[] =>
  TRANSICIONES.filter(t => t.origen === estado &&
    ((t.recurso === 'Tratar' && cap.tratar) || (t.recurso === 'Gestionar' && cap.gestionar)));

export const ACCION_LABEL: Record<EstadoCaso, string> = {
  EN_ANALISIS: 'Pasar a análisis',
  INFO_SOLICITADA: 'Solicitar información',
  RESUELTO: 'Marcar resuelto',
  CERRADO: 'Cerrar',
  RECHAZADO: 'Rechazar',
  REABIERTO: 'Reabrir',
  NUEVO: 'Nuevo',
};
